<template>
	<v-main>
		<v-overlay :value="overlay">
			<v-card
				class="mx-auto"
				max-width="375"
				outlined
			>
				<v-card-text>
					<p :class="`h5 ${ alertError ? 'red' : 'teal' }--text accent-3`">
						{{ alertError ? 'พบความผิดพลาด' : 'ทำรายการสำเร็จ' }}
					</p>
					{{ alertText }}
				</v-card-text>

				<v-card-actions>
					<v-btn
						class="ml-auto"
						outlined
						text
						@click="overlayCallback"
					>
						ตกลง
					</v-btn>
				</v-card-actions>
			</v-card>
		</v-overlay>

		<div
			ref="topPage"
			class="head-banner"
		>
			<div class="py-6">
				<v-container class="pa-0">
					<v-row no-gutters>
						<v-col
							xl="8"
							class="mx-auto px-5 px-sm-10"
						>
							<div
								class="d-flex align-start"
								style="white-space: nowrap;"
							>
								<v-btn
									color="#000"
									elevation="0"
									class="mt-n1"
									fab
									x-small
									dark
									:to="{ name: 'index' }"
								>
									<v-icon>mdi-home</v-icon>
								</v-btn>
								<v-divider
									class="mx-2 mt-3"
									style="min-width: 20px; max-width: 20px; border-color: rgba(0, 0, 0, 0.87) !important;"
								/>
								<span>
									ติดต่อเรา
								</span>
							</div>
						</v-col>
					</v-row>
				</v-container>
			</div>
			<v-row no-gutters>
				<v-col
					cols="12"
					md="5"
				>
					<div style="height: 300px;">
						<z-img
							storage="/images/2.0/contact-banner.jpg"
							max-width="100%"
							height="300"
						/>
					</div>
				</v-col>
				<v-col
					cols="12"
					md="7"
					class="bgDarkGrey pa-12 white--text"
				>
					<h1>ผู้นำด้านการขาย</h1>
					<h1>อสังหาริมทรัพย์ทุกประเภท</h1>
					<h2 class="mt-6">
						บริษัท เดอะ เบสท์ พร็อพเพอร์ตี้ เอเจนท์ จำกัด
					</h2>
					<hr class="red-strip mt-3">
				</v-col>
			</v-row>
		</div>

		<v-row no-gutters>
			<v-col
				cols="12"
				md="5"
			>
				<v-row no-gutters>
					<v-col
						cols="12"
						md="9"
						lg="8"
						xl="6"
						class="bgGray ml-auto"
					>
						<div class="red-right-border pt-12 px-10 pb-2">
							<h2>
								ติดต่อ<span class="red--text">สอบถาม</span>
							</h2>

							<img
								src="/images/2.0/LOGO.TB.CO.TH_color.png"
								alt="เดอะ เบสท์ พร็อพเพอร์ตี้ เอเจนท์ โลโก้"
								class="my-3"
								style="max-width: 100%;"
							>

							<h3 class="red--text">
								บริษัท เดอะ เบสท์ พร็อพเพอร์ตี้ เอเจนท์ จำกัด
							</h3>
							<b>สำนักงานใหญ่ เลขที่ 40/88 ซอยมัณฑนา หมู่ 5 ตำบลบางเมือง อำเภอเมือง จังหวัดสมุทรปราการ</b>
						</div>

						<div class="our-contact pa-10 pb-12">
							<a
								href="tel:020474282"
								alt="ติดต่อ The Best Property ทางโทรศัพท์ โทร 02-047-4282"
								title="ติดต่อ The Best Property ทางโทรศัพท์ โทร 02-047-4282"
								class="d-flex align-center"
							>
								<img src="/images/2.0/icon/contact/phone-grey.png">
								<div class="ml-4">
									<span>โทรศัพท์</span>
									<div class="font-weight-black red--text">02-047-4282</div>
								</div>
							</a>

							<!-- <a
								href="tel:020474283"
								alt="ติดต่อ The Best Property ทางโทรสาร โทร 02-047-4283"
								title="ติดต่อ The Best Property ทางโทรศาร โทร 02-047-4283"
								class="d-flex align-center mt-4"
							>
								<img src="/images/2.0/icon/contact/fax-grey.png">
								<div class="ml-4">
									<span>โทรสาร</span>
									<div class="font-weight-black red--text">02-047-4283</div>
								</div>
							</a> -->

							<a
								href="mailto:thebestproperty99@gmail.com"
								alt="ติดต่อ The Best Property ทางอีเมล thebestproperty99@gmail.com"
								title="ติดต่อ The Best Property ทางอีเมล thebestproperty99@gmail.com"
								class="d-flex align-center mt-4"
							>
								<img src="/images/2.0/icon/contact/mail-grey.png">
								<div class="ml-4">
									<span>อีเมล</span>
									<div class="font-weight-black red--text">thebestproperty99@gmail.com</div>
								</div>
							</a>

							<a
								href="https://line.me/ti/p/~@thebestproperty"
								target="_blank"
								alt="ติดต่อ The Best Property ทาง Line @thebestproperty"
								title="ติดต่อ The Best Property ทาง Line @thebestproperty"
								class="d-flex align-center mt-4"
							>
								<img src="/images/2.0/icon/contact/line-grey.png">
								<div class="ml-4">
									<span>LINE ID</span>
									<div class="font-weight-black red--text">@thebestproperty</div>
								</div>
							</a>

							<a
								href="https://www.facebook.com/thebestpropertyhome"
								target="_blank"
								alt="ติดต่อ The Best Property ทาง Facebook: thebestpropertyhome"
								title="ติดต่อ The Best Property ทาง Facebook: thebestpropertyhome"
								class="d-flex align-center mt-4"
							>
								<img src="/images/2.0/icon/contact/facebook-grey.png">
								<div class="ml-4">
									<span>Facebook</span>
									<div class="font-weight-black red--text">thebestpropertyhome</div>
								</div>
							</a>

							<a
								href="https://m.me/thebestpropertyhome"
								target="_blank"
								alt="สนทนากับ The Best Property"
								title="สนทนากับ The Best Property"
								class="d-flex align-center mt-4"
							>
								<img src="/images/2.0/icon/contact/messenger-grey.png">
								<div class="ml-4">
									<span>Facebook chat</span>
									<div class="font-weight-black red--text">thebestpropertyhome</div>
								</div>
							</a>
						</div>
					</v-col>
				</v-row>
			</v-col>

			<v-col
				cols="12"
				md="7"
			>
				<v-row no-gutters>
					<v-col
						cols="12"
						md="10"
						lg="9"
						xl="8"
						class="mr-auto"
					>
						<div class="pa-12">
							<h2>
								แบบฟอร์ม<span class="red--text">ติดต่อ</span>
							</h2>
							<span>ติดต่อสอบถามข้อมูลเพิ่มเติม ส่งคำถามของคุณได้ที่แบบฟอร์มด้านล่าง</span>

							<v-form
								ref="contactForm"
								v-model="contactForm"
								lazy-validation
								class="mt-6"
							>
								<v-text-field
									v-model="customerName"
									label="ชื่อและนามสกุล *"
									:rules="[ v => !!v || 'จำเป็นต้องกรอกชื่อ' ]"
									outlined
									dense
									required
								/>
								<v-text-field
									v-model="customerPhone"
									label="เบอร์โทรติดต่อ *"
									maxlength="10"
									:rules="[ v => !!v || 'จำเป็นต้องระบุหมายเลขโทรศัพท์', v => (v && /[\d]{10}/.test(v)) || 'เบอร์โทรศัพท์ไม่ถูกต้อง' ]"
									outlined
									dense
									required
									@keyup="phoneFormat"
								/>
								<v-text-field
									v-model="text"
									label="เรื่องติดต่อ"
									outlined
									dense
								/>
								<v-textarea
									v-model="additionalDetail"
									label="ฝากข้อความถึงเรา"
									auto-grow
									outlined
									rows="8"
									row-heights="15"
								/>
							</v-form>

							<div class="d-flex align-self-center">
								<!-- <v-btn
									color="grey lighten-2"
									depressed
									light
									tile
									@click="clearCiteria"
								>
									ล้างข้อมูล
								</v-btn> -->
								<v-btn
									class="btn-red-gradient white--text flex-grow-1 flex-lg-grow-0 ml-auto"
									:loading="loading"
									:disabled="loading"
									depressed
									tile
									@click="submitQuery();"
								>
									ส่งข้อความ
								</v-btn>
								<v-btn
									class="triangle-botleft btn-black-gradient white--text flex-grow-0 flex-shrink-1"
									:disabled="loading"
									depressed
									tile
									@click="submitQuery();"
								>
									<v-icon>
										mdi-arrow-right
									</v-icon>
								</v-btn>
							</div>
						</div>
					</v-col>
				</v-row>
			</v-col>
		</v-row>

		<div style="height: 400px; position: relative;">
			<iframe
				src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d6521.723565005797!2d100.61683185441389!3d13.606580364057338!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x311d5f184252485f%3A0xfd7d3fc9c3073e0e!2sThe%20Best%20Property%20Agent!5e0!3m2!1sth!2sth!4v1600663670867!5m2!1sth!2sth"
				frameborder="0"
				style="border: 0px none; position: absolute; left: 0px; width: 100%; height: 100%; border:0;"
				allowfullscreen=""
				aria-hidden="false"
				tabindex="0"
			/>
		</div>

		<!-- <div>
			<v-container class="pa-6">
				<v-row no-gutters>
					<v-col
						xl="8"
						class="mx-auto"
					>
						.
					</v-col>
				</v-row>
			</v-container>
		</div> -->
	</v-main>
</template>

<script>
const doc = 'contact'

import { mapGetters } from 'vuex'

export default {
	// scrollToTop: true,
	name: 'CONTACT',
	layout: 'default_2',

	components: {

	},

	async fetch(context) {
		let data = {
			doc,
			fullPath: context.route.fullPath
		}
		await context.store.dispatch('page/initial', data)
	},

	data:() => ({
		loading: false,

		alertError: false,
		alertText: '',
		overlay: false,
		overlayCallback: null,

		contactForm: false,
		customerPhone: null,
		customerName: null,
		text: null,
		additionalDetail: null,
	}),

	computed: {
		...mapGetters({
			isMobile: 'isMobile',
			head: 'page/head',
		}),
	},

	watch: {

	},

	created() {

	},

	mounted() {

	},

	methods: {
		phoneFormat () {
			this.customerPhone = this.customerPhone.replaceAll(/\D/g, '')
		},

		submitQuery () {
			if (!this.$refs.contactForm.validate()) {
				return
			}

			this.loading = true
			this.$fireFunc.httpsCallable('customer-contact')({
				customer_name: this.customerName,
				customer_phone: this.customerPhone,
				text: this.text,
				additional_detail: this.additionalDetail,
				source: 'contact-us'
			}).then(({data}) => {
				if (data.error) {
					this.alert({
						error: true,
						text: 'ไม่สามารถทำรายการได้ กรุณาทำรายการใหม่อีกครั้งภายหลัง หรือติดต่อผู้ดูแลระบบ',
						callback: () => {
							this.overlay = false
						}
					})
				} else {
					this.alert({
						error: false,
						text: 'เราได้รับคำขอของคุณแล้ว เดอะ เบสท์ พร็อพเพอร์ตี้ เอเจนท์ ขอขอบคุณที่ท่านให้ความสนใจในบริการของเรา เราจะติดต่อกลับท่านโดยเร็วที่สุด',
						callback: () => {
							this.overlay = false
						}
					})
				}
			}).catch(() => {
				this.alert({
					error: true,
					text: 'ไม่สามารถทำรายการได้ กรุณาทำรายการใหม่อีกครั้งภายหลัง หรือติดต่อผู้ดูแลระบบ',
					callback: () => {
						this.overlay = false
					}
				})
			}).finally(() => {
				this.$refs.contactForm.reset()
				this.loading = false
			})
		},

		alert (config) {
			this.alertError = config.error
			this.alertText = config.text
			this.overlayCallback = config.callback || (() => {})
			this.overlay = true
		},
	},

	head() {
		return this.head(doc)
	}
}
</script>

<style lang="scss" scoped>
.bgDarkGrey {
	background-color: #3a3a3a;
}
.head-banner {
	position: relative;

	.red-strip {
		border: solid 2px #c20000;
		width: 40px;
	}
}
.red-right-border {
	border-right: solid 4px #c20000;
}
.our-contact {
	a {
		color: #000;
    text-decoration: none;

		img {
			width: 50px;
		}
	}
}
::v-deep {
	.v-text-field fieldset,.v-text-field .v-input__control, .v-text-field .v-input__slot {
		border-radius: 0;
	}
	.v-text-field--outlined.v-input--has-state fieldset {
		border-color: #c20000;
	}
}
</style>
